module.exports = __webpack_public_path__ + "img/2.f6b8630b.png";